<template>
    <section class="ci-filter-date-select d-flex flex-column">
        <vue-custom-scrollbar>
            <!-- <div class="toggle-check-all">
                <ci-button @click="toggleCheckAll" :text="selectedDatesArray.length > 0 ? 'Desmarcar todos' : 'Marcar todos'" small block></ci-button>
            </div> -->
            <el-tree
                ref="tree-list"
                :data="formattedDates"
                :props="defaultProps"
                node-key="id"
                show-checkbox
                @check-change="handleCheckChange"
                empty-text="N/A"
            >
                <span class="custom-tree-node d-flex align-items-center" slot-scope="{ node, data }">
                    <p v-if="data.children" class="text-12 text-weight-bold">{{ getParentLabel(data) }}</p>
                    <span v-else class="text-12">{{ data.label }}</span>
                </span>
            </el-tree>
        </vue-custom-scrollbar>
    </section>
</template>

<script>
import VueCustomScrollbar from 'vue-custom-scrollbar'

export default {
    props: {
        value: {},
        dates: {
            type: Array,
        },
    },
    components: {
        VueCustomScrollbar,
    },
    data() {
        return {
            selectedDatesArray: [],
            selectedDatesIdArray: [],
            formattedDates: [
                // {
                //     label: '',
                //     month: 0,
                //     year: 0,
                //     children: [
                //          { label: '' }
                //     ]
                // }
            ],
            defaultProps: {
                children: 'children',
                label: 'label',
            },
        }
    },
    watch: {
        dates() {
            this.formatDates()
        },
        value() {
            this.getSelectedIds()
            this.updateSelectedNodes()
        },
    },
    methods: {
        toggleCheckAll() {
            if (this.selectedDatesArray.length > 0) {
                this.$refs['tree-list'].setCheckedKeys([])
            } else {
                this.$refs['tree-list'].setCheckedKeys(this.formattedDates.map((date) => date.id))
            }
        },
        formatDates() {
            let idCounter = 0
            if (this.dates) {
                this.dates.forEach((date) => {
                    let auxDate = {
                        day: date.split('/')[0],
                        month: date.split('/')[1],
                        year: date.split('/')[2],
                    }
                    let groupIndex = this.isFormattedDatesGroup(auxDate.month, auxDate.year)
                    if (groupIndex != -1) {
                        this.formattedDates[groupIndex].children.push({ id: idCounter++, label: date })
                    } else {
                        this.formattedDates.push({
                            id: idCounter++,
                            label: auxDate.month + '/' + auxDate.year,
                            month: auxDate.month,
                            year: auxDate.year,
                            children: [
                                {
                                    id: idCounter++,
                                    label: date,
                                },
                            ],
                        })
                    }
                })
            }
        },
        isFormattedDatesGroup(month, year) {
            let auxIndex = -1
            this.formattedDates.forEach((date, index) => {
                if (date.month == month && date.year == year) auxIndex = index
            })
            return auxIndex
        },
        getParentLabel(data) {
            return this.$t('month' + Number(data.month)) + ' - ' + data.year
        },
        handleCheckChange(data, checked, indeterminate) {
            this.selectedDatesArray = []
            let checkedNodes = this.$refs['tree-list'].getCheckedNodes()

            checkedNodes.forEach((node) => {
                if (!node.children) {
                    this.selectedDatesArray.push(node.label)
                }
            })

            this.$emit('input', this.selectedDatesArray)
        },
        getSelectedIds() {
            this.selectedDatesIdArray = []

            this.formattedDates.forEach((node) => {
                node.children.forEach((childNode) => {
                    if (this.isSelected(childNode.label)) {
                        this.selectedDatesIdArray.push(childNode.id)
                    }
                })
            })
        },
        isSelected(date) {
            return this.value.includes(date)
        },
        updateSelectedNodes() {
            setTimeout(() => {
                this.$refs['tree-list'].setCheckedKeys(this.selectedDatesIdArray)
            }, 0)
        },
    },
    mounted() {
        this.formatDates()
        this.getSelectedIds()
        this.updateSelectedNodes()
    },
}
</script>

<style lang="scss" scoped>
@import '@/scss/components/Utils/custom-filter-date-select.scss';
</style>

<style lang="scss">
@import '@/scss/components/Utils/custom-filter-date-select-global.scss';
</style>
